import { createFileRoute } from '@tanstack/react-router';
import { LeaveApprovals } from '@/features/leave/LeaveApprovals';

/** Approvazione assenze (manager/HR): pagina propria da quando `/leave` è tornata alla
 *  veste calendario + saldi. Coda submitted/manager_approved, azioni dal drawer. */
export const Route = createFileRoute('/_app/leave/approvals')({ component: LeaveApprovals });
